import { toDate } from "./toDate.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isAfter(date, dateToCompare) {
  return +toDate(date) > +toDate(dateToCompare);
}

/*                                */
export default isAfter;
